// Presentation (borders, stacking on mobile) lives in CSS, never in the JSON (spec section 15).
export default function TableBlock({ block }) {
  const columns = block.columns || [];
  const rows = block.rows || [];
  return (
    <div className="content-table-wrap">
      <table className="content-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} scope="col">{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, r) => (
            <tr key={r}>
              {columns.map((col) => (
                <td key={col.key} data-label={col.label}>{row[col.key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
